import { render } from "./supplier-list.vue?vue&type=template&id=d82b20dc"
import script from "./supplier-list.vue?vue&type=script&lang=js"
export * from "./supplier-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__